/** @deprecated Format `computerUseMessages.notStartedReason` at the render boundary. */
export const COMPUTER_USE_NOT_STARTED_USER_MESSAGE = "Didn't start working the screen.";

/** @deprecated Format `computerUseMessages.stoppedReason` at the render boundary. */
export const CANCELLED_USER_MESSAGE = 'Stopped working the screen.';

const LEGACY_CANCELLED_USER_MESSAGE = 'Desktop task was cancelled.';

// Wording before the rename to "Working the screen". Runs already in flight,
// and every historical transcript, still carry it.
const LEGACY_COMPUTER_USE_CANCELLED_USER_MESSAGE = 'Computer use stopped.';

const EXACT_CANCELLATION_MESSAGES = new Set([
  CANCELLED_USER_MESSAGE.toLowerCase(),
  LEGACY_CANCELLED_USER_MESSAGE.toLowerCase(),
  LEGACY_COMPUTER_USE_CANCELLED_USER_MESSAGE.toLowerCase(),
  'rpa task cancelled',
  'rpa task canceled',
  'session cancelled',
  'session canceled',
  'cancelled',
  'canceled',
]);

export const readComputerUseProgressRecap = (
  metadata: Record<string, unknown> | undefined
): string | undefined => {
  const recap = metadata?.progress_recap;
  return typeof recap === 'string' && recap.trim() ? recap.trim() : undefined;
};

export const isComputerUseCancellationMessage = (raw: string | undefined): boolean => {
  const lower = raw?.trim().toLowerCase();
  if (!lower) return false;
  if (EXACT_CANCELLATION_MESSAGES.has(lower)) return true;
  if (lower.includes('rpataskcancellederror')) return true;

  return (
    /\b(?:rpa|desktop|computer use|task|session|turn|run)\b.*\bcancell?ed\b/.test(
      lower
    ) ||
    /\bcancell?ed\b.*\b(?:rpa|desktop|computer use|task|session|turn|run)\b/.test(
      lower
    ) ||
    /\bapproval\b.*\bdenied\b/.test(lower) ||
    /\bdenied\b.*\bapproval\b/.test(lower)
  );
};
